// Only an explicit capability from authorized organization discovery enables the UI.
// Missing/legacy local selections fail closed; institution names never grant access.
export function isCohortRealtimeAvailable(cohort) {
  return typeof cohort?.id === 'string' && cohort.id.length > 0 && cohort.realtime_monitoring_enabled === true
}

export function createCohortRealtimeGuard(getCohort) {
  return () => isCohortRealtimeAvailable(getCohort()) || { name: 'CohortOverview' }
}
